/**
 * @generated SignedSource<<8d502881405ce8a3ca2af60d5278ab67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingleGroupingMode = "SECTION" | "TEAM";
export type WidgetTaskSingleSize = "ONE_X_ONE" | "TWO_X_ONE";
export type PreviewWidgetTaskSingleInput = {
  grouping: WidgetTaskSingleGroupingMode;
  id: string;
  sectionIds: ReadonlyArray<string>;
  taskId: string;
  taskSingleSize: WidgetTaskSingleSize;
  teamIds: ReadonlyArray<string>;
};
export type WidgetTaskSinglePreviewQuery$variables = {
  input: PreviewWidgetTaskSingleInput;
  storecastId: string;
};
export type WidgetTaskSinglePreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetTaskSingle: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingle_widgetTaskSingle">;
    };
  };
};
export type WidgetTaskSinglePreviewQuery = {
  response: WidgetTaskSinglePreviewQuery$data;
  variables: WidgetTaskSinglePreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sectionId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTaskSinglePreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "WidgetTaskSingle",
              "kind": "LinkedField",
              "name": "previewWidgetTaskSingle",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetTaskSingle_widgetTaskSingle"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetTaskSinglePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "WidgetTaskSingle",
            "kind": "LinkedField",
            "name": "previewWidgetTaskSingle",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grouping",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskSingleSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "activeSectionVersions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ordinal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Routine",
                    "kind": "LinkedField",
                    "name": "routine",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Schedule",
                            "kind": "LinkedField",
                            "name": "schedule",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecurrenceRule",
                                "kind": "LinkedField",
                                "name": "rules",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "freq",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "TaskNumberOccasionConnection",
                        "kind": "LinkedField",
                        "name": "occasions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskNumberOccasionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskNumberOccasion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoutineOccasion",
                                    "kind": "LinkedField",
                                    "name": "occasion",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskExecutionNumber",
                                    "kind": "LinkedField",
                                    "name": "taskExecutions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numberValue",
                                        "storageKey": null
                                      },
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskNumberGoals",
                                        "kind": "LinkedField",
                                        "name": "goals",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "lessThan",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "greaterThan",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "occasions(first:8)"
                      }
                    ],
                    "type": "TaskNumber",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "TaskCheckOccasionConnection",
                        "kind": "LinkedField",
                        "name": "occasions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskCheckOccasionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskCheckOccasion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoutineOccasion",
                                    "kind": "LinkedField",
                                    "name": "occasion",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v3/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskExecutionCheck",
                                    "kind": "LinkedField",
                                    "name": "taskExecutions",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "checkValue",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "occasions(first:8)"
                      }
                    ],
                    "type": "TaskCheck",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1aa5f03c0cf9378b5571bd2d39d6d508",
    "id": null,
    "metadata": {},
    "name": "WidgetTaskSinglePreviewQuery",
    "operationKind": "query",
    "text": "query WidgetTaskSinglePreviewQuery(\n  $input: PreviewWidgetTaskSingleInput!\n  $storecastId: ID!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetTaskSingle(input: $input) {\n      ...WidgetTaskSingle_widgetTaskSingle\n      id\n    }\n    id\n  }\n}\n\nfragment SingleTaskInProgressCheck_taskExecutionCheck on TaskExecutionCheck {\n  ...taskExecutionListCheckTaskExecutions\n  checkValue\n  updatedAt\n}\n\nfragment WidgetTaskSingleCheckSmallInProgress_taskExecutions on TaskExecutionCheck {\n  checkValue\n  ...taskExecutionListCombineCheckTaskExecutions\n}\n\nfragment WidgetTaskSingleCheck_taskCheck on TaskCheck {\n  id\n  title\n  routine {\n    id\n    title\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        ...WidgetTaskSingleCheck_taskCheckOccasion\n        taskExecutions {\n          id\n          checkValue\n          sectionId\n          ...WidgetTaskSingleCheckSmallInProgress_taskExecutions\n          ...SingleTaskInProgressCheck_taskExecutionCheck\n        }\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingleCheck_taskCheckOccasion on TaskCheckOccasion {\n  id\n  occasion {\n    startAt\n    endAt\n    id\n  }\n  taskExecutions {\n    sectionId\n    checkValue\n    id\n  }\n}\n\nfragment WidgetTaskSingleNumberOccasionPage_taskNumber on TaskNumber {\n  id\n  unit\n  title\n  routine {\n    id\n    title\n    type\n    schedule {\n      rules {\n        freq\n      }\n    }\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n        taskExecutions {\n          numberValue\n          sectionId\n          goals {\n            lessThan\n            greaterThan\n          }\n          ...useGroupNumberTaskExecution_taskExecutionNumber\n          updatedAt\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingle_widgetTaskSingle on WidgetTaskSingle {\n  id\n  title\n  grouping\n  taskSingleSize\n  ...useWidgetTaskSingleSections_widgetTaskSingle\n  activeSectionVersions {\n    section {\n      id\n    }\n    id\n  }\n  task {\n    id\n    routine {\n      id\n      type\n      title\n    }\n    __typename\n    ... on TaskNumber {\n      ...WidgetTaskSingleNumberOccasionPage_taskNumber\n    }\n    ... on TaskCheck {\n      ...WidgetTaskSingleCheck_taskCheck\n    }\n  }\n}\n\nfragment taskExecutionListCheckTaskExecutions on TaskExecutionCheck {\n  id\n  sectionId\n  checkValue\n}\n\nfragment taskExecutionListCombineCheckTaskExecutions on TaskExecutionCheck {\n  checkValue\n}\n\nfragment useGroupNumberTaskExecution_taskExecutionNumber on TaskExecutionNumber {\n  id\n  sectionId\n  numberValue\n  updatedAt\n  goals {\n    lessThan\n    greaterThan\n  }\n}\n\nfragment useWidgetTaskSingleSections_widgetTaskSingle on WidgetTaskSingle {\n  activeSectionVersions {\n    id\n    title\n    ordinal\n    section {\n      id\n      assignedTeam {\n        id\n        name\n        color\n        icon\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2466fdab905bc675d5f48ed9e8d40891";

export default node;
